import { render, staticRenderFns } from "./SafetyCardPdf.vue?vue&type=template&id=82543914&"
import script from "./SafetyCardPdf.vue?vue&type=script&lang=js&"
export * from "./SafetyCardPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports